@import '~style-sheet-helpers/core.less';
@import '../../app-brand/entities/entity-layer.module.less';

.cover {
  position: absolute;
  overflow: hidden;
  inset: 115px 0 0;
  background-color: @scan-page--body-cover--background-color;
  opacity: 0.5;
  pointer-events: all;
}
